<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      {{ title }}
    </Teleport>

    <p class="cf-subtitle cf-subtitle--2">
      {{ itemDescription }}
    </p>

    <cf-star-rating
      :selected-value="localStateItemRating"
      @set-selected-value="selectValueClickHandler"
    />

    <button
      :class="['cf-button cf-button--primary cf-button--lg cf-button--fill', { 'cf-button--loading': isLoading }]"
      type="button"
      :disabled="isDisabled"
      @click="submitItemRatingClickHandler"
    >
      {{ buttonCtaContent }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import CfStarRating from '@/view/components/shared/cf-star-rating/index.vue';


  export default {
    name: 'CfOrderItemRating',

    components: {
      CfStarRating
    },

    props: {
      item: {
        type: Object,
        required: true
      },

      itemRating: {
        type: Number,
        default: 0
      },

      order: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        localStateItemRating: null,
        previousRating: null,
        hasUserUpdatedRating: false,
        isLoading: false
      };
    },

    computed: {
      ...mapGetters('content', ['content']),

      title() {
        return this.content.ItemRating.title;
      },

      itemDescription() {
        return this.item.itemDescription;
      },

      buttonCtaContent() {
        return this.content.ItemRating.metadata.cta;
      },

      userHasUpdatedRating() {
        return this.previousRating !== this.localStateItemRating;
      },

      isDisabled() {
        return this.localStateItemRating === 0;
      }
    },

    mounted() {
      const initialRating = this.itemRating ?? 0;

      this.previousRating = initialRating;

      this.localStateItemRating = initialRating;
    },

    unmounted() {
      this.previousRating = null;

      this.localStateItemRating = null;
    },

    methods: {
      async submitItemRatingClickHandler() {
        /**
         * NOTE:
         * Compare the users previous rating that is originally fetched from order history.
         * If localStateItem changed then update the item rating
         */
        if (this.userHasUpdatedRating) {
          try {
            this.isLoading = true;

            const dispatchPayload = {
              rating: this.localStateItemRating,
              orderId: this.order.orderId,
              menuItemId: this.item.menuItemId
            };

            this.$store.dispatch('orderHistory/submitOrderItemRating', dispatchPayload);

            this.$closeModal('order-item-rating-modal');
          }
          catch (error) {
            errorHandlers.generic(error);
          }
          finally {
            this.sLoading = false;
          }
        }
        else {
          this.$closeModal('order-item-rating-modal');
        }
      },

      selectValueClickHandler(selectedValue) {
        this.localStateItemRating = selectedValue;
      }
    }
  };
</script>
